import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';

export const GET_VEHICLES = gql`
  query getVehicles {
    myVehicles {
      guid
      imageUrl
      make
      makeId
      model
      modelId
      nickname
      year
    }
  }
`;

export const CREATE_VEHICLE_PROFILE = gql`
  mutation CreateVehicleProfile($vehicle: NewVehicleInput!) {
    createVehicle(vehicle: $vehicle) {
      guid
      imageUrl
      make
      makeId
      model
      modelId
      nickname
      recalls {
        recallId
      }
      year
    }
  }
`;

export default function useCreateVehicleMutation({ onCompleted }) {
  const [createVehicleProfile, { data: vehicleCreationResult, ...rest }] = useMutation(CREATE_VEHICLE_PROFILE, {
    onCompleted: () => {
      onCompleted();
    },
    update(cache, { data }) {
      const cachedVehicles = cache.readQuery({ query: GET_VEHICLES });
      if (cachedVehicles) { // we may not have loaded the above query yet, so no need to update the cache
        const newVehiclesList = [...cachedVehicles.myVehicles, data.createVehicle];
        cache.writeQuery({
          query: GET_VEHICLES,
          data: {
            myVehicles: newVehiclesList,
          },
        });
      }
    },
  });

  return [createVehicleProfile, { data: vehicleCreationResult?.createVehicle, ...rest }];
}
